import React, { useState, useEffect, useRef} from 'react'
import { getFileName } from '../../../helpers/FileCaching';
import classes from './Articles.module.scss'
import { Link  } from "react-router-dom";
import globalJSON from 'data/global.json';


function onClick(event){
	window.gtag('event', "promo article selection", {
		'event_category': globalJSON.tracking.ga_category,
		'event_label': "promo article clicked "+ event.currentTarget.href,
		'value':10
	});
}

const Posts = ({ postsToRender }) => {
	const globalImages = require.context('../../../images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);
	return (
	<div className={classes.articles__wrapper}>
	  {postsToRender.map((item, index) => (
			<div key={index} className={classes.articles__article}>
			<Link onClick={onClick} to={process.env.PUBLIC_URL+item.url} className={` ${classes['articles__article--link']}`}>
				<div className={classes['articles__article--image_wrapper']}>
					<div className={` ${classes['articles__article--container-image']}`}>
						<img className={`${classes['articles__article--image']}`} alt={item.imgTitle} src={getFileName(globalImages, item.image)}></img>
					</div>
				</div>
				{/* <p className={`subtitle_white_global ${classes.articles__article__subtitle}`}>{item.subtitle}</p> */}
				<h3 className={classes['articles__article--title']}>{item.title}</h3>
				<div className={'divider_grey_article'}></div>
			</Link>
		</div>
	  ))}

	</div>
  );
};



function Articles({content, globalImages, windowSize}){
	
	const postsPerPage = 8;
	let arrayForHoldingPosts = useRef([]);

	const [postsToShow, setPostsToShow] = useState([]);
	const [hasMorePosts, setHasMorePosts] = useState(false);
	const [next, setNext] = useState(postsPerPage);
  
	const loopWithSlice = (start, end) => {
	  const slicedPosts = content.articles.slice(start, end);
	  arrayForHoldingPosts.current = [...arrayForHoldingPosts.current, ...slicedPosts];
	  setPostsToShow(arrayForHoldingPosts.current);

	};
  
	useEffect(() => {
	  	loopWithSlice(0, postsPerPage);
		
		if(content.articles.length > postsPerPage){
			setHasMorePosts(true)
		}
	  
	}, []);

	useEffect(() => {
		//Once the view count has increased,  lets check to see if its at the end
		if(next >= content.articles.length){

			//Hide next option - there's no more to show
			setHasMorePosts(false)

		}
	
  }, [next]);
  
	const handleShowMorePosts = () => {

		loopWithSlice(next, next + postsPerPage);
		setNext(next + postsPerPage);

	};



	let articles = content.articles.map((item, index) => 
		<div key={index} className={classes.articles__article}>
			<Link onClick={onClick} to={process.env.PUBLIC_URL+item.url} className={` ${classes['articles__article--link']}`}>
					<div className={`border-hover  ${classes['articles__article--image_wrapper']}`}>
						<div className={` ${classes['articles__article--container-image']}`}>
						{/* <div style={{backgroundImage: `url(${getFileName(globalImages, item.image)})`}} className={`${classes['articles__article--image']}`}></div> */}
							<img className={`${classes['articles__article--image']}`} alt={item.title} src={getFileName(globalImages, item.image)}></img>
						</div>
					</div>
					{/* <p className={`subtitle_white_global ${classes.articles__article__subtitle}`}>{item.subtitle}</p> */}
					<h3 className={classes['articles__article--title']}>{item.title}</h3>
					<div className={'divider_grey_article'}></div>
				
			</Link>
		</div>

	)
		
	return (
		<div className={classes.articles}>
			<div className={`col-md-12`} style={{padding: 0}}>
				<Posts postsToRender={postsToShow} />
				{(hasMorePosts
					?
					<div className={classes.articles__btn_wrap}>
						<button className={`subtitle_white_global ${classes.articles__btn}`} onClick={handleShowMorePosts}>See more</button>
					</div>
					:
					""
				)}
			</div>
			<div style={{display:"none"}}>
				{content.articles.map((item, index) => (
					<div key={index} className={classes.articles__article}>
						<Link onClick={onClick} to={process.env.PUBLIC_URL+item.url} className={` ${classes['articles__article--link']}`}>
							{item.title}
						</Link>
					</div>
				))}
			</div>
		</div>
	)
}

export default Articles;




